import React from 'react';
import { formatPreparationEvidenceCitation } from './preparationSourceAuthors';
import { Button, Stack, Typography } from '@mui/material';
import LogFormShell from '../../components/UI/LogFormShell';
import colors from '../../assets/theme/colors';

const PreparationProfileSourceSheet = ({ open, item, canEdit, onClose, onEdit, onOpenOriginal }) => (
  <LogFormShell
    open={open}
    onClose={onClose}
    title={item?.contextLabel || 'Profile information'}
    subtitle={item ? formatPreparationEvidenceCitation(item) : 'Current Profile'}
  >
    <Stack spacing={2} sx={{ p: { xs: 2, md: 2.5 } }}>
      <Typography sx={{ fontSize: '1rem', lineHeight: 1.55, color: colors.semantic.ink }}>
        {item?.description || item?.label}
      </Typography>
      {canEdit ? (
        <Button onClick={onEdit} variant="outlined" sx={{ alignSelf: 'flex-start', borderRadius: '999px', textTransform: 'none', fontWeight: 700 }}>
          Edit in Profile
        </Button>
      ) : null}
      {item?.originalSourceRef ? (
        <Button onClick={onOpenOriginal} sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 700 }}>
          View original capture
        </Button>
      ) : null}
    </Stack>
  </LogFormShell>
);

export default PreparationProfileSourceSheet;
